"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const playlists_1 = require("../../api/playlists");
const playlistImages_1 = require("../../components/playlists/playlistImages");
const TracksType_1 = require("../../types/TracksType");
const createElement_1 = require("../../utils/dom/createElement");
const generateIndexes_1 = require("../../utils/tracks/generateIndexes");
const getTracksCountString_1 = require("../../utils/tracks/getTracksCountString");
class AddTrackModalService {
    constructor(modalService, playlistsModel, playerModel) {
        this.modalService = modalService;
        this.playlistsModel = playlistsModel;
        this.playerModel = playerModel;
    }
    open(songId) {
        const modalDiv = this.createModalElement();
        this.createPlaylistButtons(modalDiv, songId);
        this.addCancelHandler(modalDiv);
        this.modalService.open(modalDiv);
    }
    close() {
        this.modalService.close();
    }
    createModalElement() {
        return (0, createElement_1.createElement)(`
      <div class="playlists-modal">
          <div class="playlists-modal__title">
              Добавить в плейлист
          </div>
          <div class="playlists-modal__playlist_content">
          </div>
          <div class="playlists-modal__footer">
              <div class="playlists-modal__close-btn">
                  Отменить
              </div>
          </div>
      </div>
    `);
    }
    addCancelHandler(modalDiv) {
        const cancelButton = modalDiv.querySelector('.playlists-modal__close-btn');
        if (!cancelButton) {
            throw new Error('playlists-modal__close-btn is not found');
        }
        cancelButton.addEventListener('click', () => this.close());
    }
    createPlaylistButtons(modalDiv, songId) {
        const buttonsContainer = modalDiv.querySelector('.playlists-modal__playlist_content');
        for (const playlist of this.playlistsModel.getFilteredForAddition(songId)) {
            const playlistButton = this.createPlaylistButton(playlist);
            playlistButton.addEventListener('click', async () => {
                this.close();
                const newPlaylist = await (0, playlists_1.addToPlaylist)(playlist.id, songId);
                this.playlistsModel.update(playlist.id, newPlaylist);
                if (this.playerModel.tracksType === TracksType_1.TracksType.Playlist &&
                    this.playerModel.playlistId === newPlaylist.id) {
                    this.playerModel.originalTracks = (0, generateIndexes_1.generateIndexes)(newPlaylist.songs);
                    this.playerModel.onTrackListChange();
                }
            });
            buttonsContainer === null || buttonsContainer === void 0 ? void 0 : buttonsContainer.append(playlistButton);
        }
    }
    createPlaylistButton(playlist) {
        const imageId = playlist.id % playlistImages_1.PLAYLIST_IMAGES.small.length;
        const imageSrc = playlistImages_1.PLAYLIST_IMAGES.small[imageId];
        const countString = (0, getTracksCountString_1.getTracksCountString)(playlist.songs.length);
        if (!imageSrc) {
            throw new Error(`Image with id: ${imageId} not found`);
        }
        return (0, createElement_1.createElement)(`
      <div class="playlists-modal__playlist">
          <img src="${imageSrc}" alt="" class="playlists-modal__playlist__image"/>
          <div class="playlists-modal__playlist__title">
            ${playlist.name}
          </div>
          <div class="playlists-modal__playlist__info">
            ${countString}
          </div>
      </div>
    `);
    }
}
exports.default = AddTrackModalService;
